export const normalizeLineupStatus = (value = "") => {
  const normalizedValue = String(value || "").trim().toUpperCase();

  if (normalizedValue === "PLAYING") return "PLAYING";
  if (normalizedValue === "SUBSTITUTE") return "SUBSTITUTE";
  if (normalizedValue === "NOT_PLAYING") return "NOT_PLAYING";
  return "";
};

export const isLineupOutForMatch = (matchData = {}) => {
  const rawStatus =
    matchData?.status?.status ||
    matchData?.status ||
    matchData?.matchStatus ||
    "";
  const normalizedStatus = String(rawStatus).trim().toLowerCase();

  return (
    matchData?.lineupOut === true ||
    matchData?.lineupsOut === true ||
    normalizedStatus === "lineup_out" ||
    normalizedStatus === "live"
  );
};

export const getResolvedLineupStatus = (player = {}) => {
  const explicitStatus = normalizeLineupStatus(player?.lineupStatus);
  if (explicitStatus) return explicitStatus;

  if (player?.isPlaying === true) return "PLAYING";
  if (player?.isPlaying === false) return "NOT_PLAYING";

  return "";
};

export const getPlayerLineupIndicator = (player = {}) => {
  const lineupStatus = getResolvedLineupStatus(player);

  if (lineupStatus === "PLAYING") {
    return {
      key: "playing",
      label: "Playing",
      color: "#198754",
    };
  }

  if (lineupStatus === "SUBSTITUTE") {
    return {
      key: "substitute",
      label: "Substitute",
      color: "#0d6efd",
    };
  }

  if (lineupStatus === "NOT_PLAYING" && player?.playedLastMatch) {
    return {
      key: "played-last-match",
      label: "Played last match",
      color: "#fd7e14",
    };
  }

  if (lineupStatus === "NOT_PLAYING") {
    return {
      key: "not-playing",
      label: "Not Playing",
      color: "#dc3545",
    };
  }

  return null;
};

export const getPlayerLineupSortRank = (player = {}) => {
  const lineupStatus = getResolvedLineupStatus(player);

  if (lineupStatus === "PLAYING") return 0;
  if (lineupStatus === "SUBSTITUTE") return 1;
  if (lineupStatus === "NOT_PLAYING") return 3;
  return 2;
};

export const isPlayerEligibleForLeadership = (player = {}, shouldEnforce = false) => {
  if (!shouldEnforce) return true;

  const lineupStatus = getResolvedLineupStatus(player);
  if (lineupStatus) {
    return lineupStatus === "PLAYING";
  }

  return player?.isPlaying !== false;
};
